import React from "react";
import {
  Card,
  RadioGroup,
  Radio,
  FormControlLabel,
  Typography
} from "@mui/material";

const SelectTestType = ({ testType, handleTestTypeChange }) => {
  return (
    <Card className="test-type-card">
      <Typography variant="h6" className="section-title">
        Select Test Type
      </Typography>

      <RadioGroup
        value={testType}
        onChange={handleTestTypeChange}
        className="test-type-group"
      >
        <div className={`test-type-option1 ${testType === "browser" ? "selected browser" : ""}`}>
          <FormControlLabel
            value="browser"
            control={<Radio color="primary" />}
            label={<Typography variant="subtitle1">On Browser</Typography>}
          />
          <Typography variant="body2" className="option-description">
            Select this option to test the function on specific browser with specific scenario
          </Typography>
        </div>

        <div className={`test-type-option2 ${testType === "script" ? "selected script" : ""}`}>
          <FormControlLabel
            value="script"
            control={<Radio color="primary" />}
            label={<Typography variant="subtitle1">Script</Typography>}
          />
          <Typography variant="body2" className="option-description">
            Select this option to test the function for testing the back-end script like API response for the specific function
          </Typography>
        </div>
      </RadioGroup>
    </Card>
  );
};

export default SelectTestType;
